import React from 'react'
import styles from "./contact.module.css"
import { maskPhone } from '../../../../utils/formatter'
import { MdOutlineChatBubbleOutline } from 'react-icons/md'
import { useWebSocketChatContext } from '../../../../contexts/webSocketChatContext'
import ImageWithFallback from '../../../ImageWithFallback'

const Contact = ({ contacts = [], defaultPicture, showHeader = true, variant = "" }) => {
    const { handleOpenModalStartChat } = useWebSocketChatContext()

    const handleOpenConversation = (contact) => {
        handleOpenModalStartChat(contact?.details)
    }

    return (
        <div className={`${styles.container} ${variant ? styles[variant] || "" : ""}`.trim()}>
            {showHeader && <span className={styles.header}>Contatos: {contacts?.length}</span>}
            {contacts?.map((contact, index) => (
                <div className={styles.contact} key={index}>
                    <div className={styles.profileImage}>
                        <ImageWithFallback
                            src={contact?.details?.picture || defaultPicture}
                            alt="Imagem de Perfil"
                            functionError={() => <img src={defaultPicture} alt="Imagem de Perfil" />}
                        />
                    </div>
                    <div className={styles.info}>
                        <span className={styles.name}>{contact?.details?.name || "-"}</span>
                        <span className={styles.phone}>{maskPhone(contact?.details?.phone) || "Sem telefone"}</span>
                    </div>
                    <button
                        type="button"
                        className={styles.chatButton}
                        onClick={() => handleOpenConversation(contact)}
                        title="Conversar com contato"
                        aria-label="Conversar com contato"
                    >
                        <MdOutlineChatBubbleOutline />
                    </button>
                </div>
            ))}
        </div>
    )
}

export default Contact
